import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "altin_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setToken(data.access_token);
  return data.admin;
}

export async function adminMe() {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return data;
}

export async function fetchStats() {
  const { data } = await axios.get(`${API}/admin/stats`, { headers: authHeaders() });
  return data;
}

export async function fetchList(kind, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  );
  const { data } = await axios.get(`${API}/admin/${kind}`, {
    headers: authHeaders(),
    params: clean,
  });
  return data;
}

export async function updateItem(kind, id, patch) {
  const { data } = await axios.patch(`${API}/admin/${kind}/${id}`, patch, {
    headers: authHeaders(),
  });
  return data;
}

export async function exportData(collection, fmt) {
  const res = await axios.get(`${API}/admin/export`, {
    headers: authHeaders(),
    params: { collection, fmt },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `altinlink_${collection}.${fmt}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
